module.exports = __webpack_public_path__ + "static/img/8.c5a0dc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/8.png
// module id = 45R4
// module chunks = 0